<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow" 
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success" 
			:cancel-title="'Clear'" 
			@ok="getApprovalConfigurations"
			@hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="filter-" size="sm" :selected="filter.approvalType != null ? filter.approvalType.name : ''" :model.sync="filter.approvalTypeId" @input="getApprovalTypes" @focus="getApprovalTypes" @change="updateFilter('approvalType')" />
					<app-input-combobox-autocomplete :options="appliedTos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Applied To" id="filter-" size="sm" :selected="filter.appliedTo != null ? filter.appliedTo.name : ''" :model.sync="filter.appliedToId" @input="getAppliedTos" @focus="getAppliedTos" />
					<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getApprovalConfigurations"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
				Clear
			</b-button>
			<b-overlay
				:show="isDataLoading"
				rounded
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				class="float-right "
				>
				<b-button size="sm" class="float-right btn-default" @click="ok()">
					Search
				</b-button>
			</b-overlay>
			</template>

		</b-modal>
		<div>
			<b-row class="mb-2">
				<b-col class="pt-1">
					<span class="function-title pt-1">Approval Configuration</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">			
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" ::href="`files/ApprovalConfiguration/ApprovalConfiguration.xlsx`"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Multiple Print</b-dropdown-item>
						</b-dropdown>
						<b-overlay
							v-if="(userRole != null ? userRole.allowCreate : false)" 
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline"
						>
						<b-button class="btn-create btn-fill-success" @click="createData" size="sm">Create New</b-button>
						</b-overlay>
					</span>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action"  size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					<b-overlay
								v-if="(userRole != null ? userRole.allowDelete : false)"
								:show="isDeleteBusy"
								rounded
								opacity="0.6"
								spinner-small
								spinner-variant="primary"
								class="d-inline-block"
								>
								<click-confirm>
									<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
								</click-confirm>
							</b-overlay>
					<b-button class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> Advance Filter</b-button>
				</div>
				<b-table class="table-action" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="approvalConfigurations" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty>
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="approvalConfigurations.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(actions)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th class="th-front-action"></b-th>
						<b-th class="th-number"></b-th>
						<b-th stacked-heading="Name">
							<b-form-input id="input-name-table" @input="getApprovalConfigurationsWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Approval Type">
							<v-select append-to-body label="name" :options="approvalTypes" :value="filter.approvalTypeId" :reduce="item => item.id" v-model="filter.approvalTypeId" :filterable="true" @input="getApprovalConfigurationsWithoutLoading" @search="getApprovalTypes"></v-select>
						</b-th>
						<b-th stacked-heading="Description">
							<b-form-input id="input-description-table" @input="getApprovalConfigurationsWithoutLoading" v-model="filter.description" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Applied To">
							<v-select append-to-body label="name" :options="appliedTos" :value="filter.appliedToId" :reduce="item => item.id" v-model="filter.appliedToId" :filterable="true" @input="getApprovalConfigurationsWithoutLoading" @search="getAppliedTos"></v-select>
						</b-th>
						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					<template v-slot:cell(name)="row">
						<a @click="() => ( $router.push({ name: 'approvalconfigurationdetail', params : { id: row.item.id } }))" class="a-link-detail">{{ row.item.name }}</a>
					</template>
					<template v-slot:cell(approvalType)="row">
						{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
					</template>
					<template v-slot:cell(appliedTo)="row">
						{{ row.item.appliedTo != null ? row.item.appliedTo.name : "" }}
					</template>
					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row" >
						<div class="div-actions float-right" v-if="false">
							<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" @click="editData(row.index, row.item.id)" class="mr-2 btn-xs btn-default">
								<b-icon-pencil></b-icon-pencil>
							</b-button>
							<b-overlay
								v-if="(userRole != null ? userRole.allowDelete : false)"
								:show="busy"
								rounded
								opacity="0.6"
								spinner-small
								spinner-variant="primary"
								class="d-inline-block"
								>
								<click-confirm>
								<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs btn-default-danger">
									<b-icon-trash></b-icon-trash>
								</b-button>
								</click-confirm>
							</b-overlay>
						</div>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination
									class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(approvalConfigurationsPaging != null ? approvalConfigurationsPaging.dataCount : 0)"
									:per-page="(approvalConfigurationsPaging != null ? approvalConfigurationsPaging.pageSize : 0)"
									aria-controls="my-table"
								>
									<template #first-text><b-icon-chevron-left /></template>
									<template #prev-text>Prev</template>
									<template #next-text>Next</template>
									<template #last-text><b-icon-chevron-right /></template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationList from '@/models/ApprovalConfiguration/ApprovalConfigurationList';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {ApprovalConfiguration, ApprovalConfigurationList, ApprovalConfigurationFilter, AppInputTextbox,AppInputTextarea,AppInputComboboxAutocomplete,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : { "class" : "th-number"}}, 
				{"name": {}, "class" : "th-name", "label" : "Name", key: 'name', sortable: true}, 
				{"approvalType": {}, "class" : "th-approval-type", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"description": {}, "class" : "th-description", "label" : "Description", key: 'description', sortable: true}, 
				{"appliedTo": {}, "class" : "th-applied-to", "label" : "Applied To", key: 'appliedTo', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			approvalConfigurations: [],
			approvalConfigurationsPaging: {},
			approvalTypes : [],
			appliedTos : [],
			isFilterShow: false,
			isDeleteBusy: false,
		}
	},
	methods : {
		getApprovalConfigurations : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
					this.approvalConfigurationsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getApprovalConfigurationsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
					this.approvalConfigurationsPaging = result
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
			})
			.catch(error => {});
		},
		updateFilter(type) {
			if (type == 'approvalType') {
				let approvalTypeObj = this.approvalTypes.filter(item => item.id = this.filter.approvalTypeId);
				console.log(approvalTypeObj);
				this.filter.approvalType = approvalTypeObj;
			}
		},
		resetFilter() {
			this.filter = new ApprovalConfigurationFilter();
			this.getApprovalConfigurations();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getApprovalConfigurations();
		},
		toggleIsPrint(id) {
			console.log(id);
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ApprovalConfiguration.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ApprovalConfiguration.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			ApprovalConfiguration.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		createData() {
			this.isCreateBusy = true;
			ApprovalConfiguration.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalconfigurationedit', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			ApprovalConfiguration.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalconfigurationedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		deleteData(id) {
			ApprovalConfiguration.deleteData(this, id).then(result => {
				if (result)
				{
					this.getApprovalConfigurations();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ApprovalConfiguration.deleteMultipleData(this).then(result => {
					this.getApprovalConfigurations();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ApprovalConfigurationFilter();
		this.getApprovalTypes()
		this.getAppliedTos()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Approval Configuration"
		];
		this.getApprovalConfigurations();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		sortDesc: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		currentPage: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ApprovalConfiguration.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "approvalconfigurationindex") {
					this.getApprovalConfigurationsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "approval_configuration").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
